import api from './api';

export const getZoomStatus = () =>
  api.get('/api/v1/integrations/zoom/status').then((r) => r.data.data);

export const getZoomAuthUrl = () =>
  api.get('/api/v1/integrations/zoom/auth-url').then((r) => r.data.data);

export const completeZoomOAuth = (code, state) =>
  api.post('/api/v1/integrations/zoom/callback', { code, state }).then((r) => r.data);

export const disconnectZoom = () =>
  api.delete('/api/v1/integrations/zoom/disconnect').then((r) => r.data);
